import Splide from '@splidejs/splide';

function initializeHomeCredentialsBlock() {
    const sliders = document.querySelectorAll('.home-credentials .slider');

    sliders.forEach(function(slider) {
        if( slider.splide ) {
            slider.splide.destroy();
        }

        const perPage = Math.max(1, parseInt(slider.dataset.perPage, 10) || 4);

        const splide = new Splide(slider, {
            type: 'slide',
            rewind: false,
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 3000,
            speed: 700,
            pauseOnHover: true,
            pauseOnFocus: false,
            drag: true,
            snap: true,
            focus: 0,
            gap: 0,
            trimSpace: true,
            perPage: perPage,
            perMove: 1,
            breakpoints: {
                960: {
                    perPage: Math.min(perPage, 2)
                },
                576: {
                    perPage: 1
                }
            }
        });

        splide.mount();
        slider.splide = splide;
    });
}

document.addEventListener('DOMContentLoaded', function () {
    if( window.acf ) {
        window.acf.addAction('render_block_preview/type=home-credentials', initializeHomeCredentialsBlock);
    } else {
        initializeHomeCredentialsBlock();
    }
});
